import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const ServicesTableRow = ({
    service,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(service.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, service.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic
                    ? (service?.name?.ar || service?.name?.en || (typeof service?.name === 'string' ? service.name : '-'))
                    : (service?.name?.en || service?.name?.ar || (typeof service?.name === 'string' ? service.name : '-'))
                }
            </TableCell>

            {/* Slug */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {service?.slug
                    ? <Chip label={service.slug} size="small" variant="outlined" sx={{ borderRadius: '6px', fontWeight: 'bold', fontFamily: 'monospace' }} />
                    : '-'
                }
            </TableCell>

            {/* السعر */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {service?.price ? `${service.price} $` : '-'}
            </TableCell>

            {/* الحالة */}
            <TableCell align="center">
                <Chip
                    label={service?.is_active ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    size="small"
                    color={service?.is_active ? 'success' : 'default'}
                    variant="outlined"
                    sx={{ borderRadius: '6px' }}
                />
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {service?.created_at ? dayjs(service.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, service)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ServicesTableRow;